import { render, staticRenderFns } from "./addgeonotificationonwidgetmodal.vue?vue&type=template&id=55d6a197&scoped=true"
import script from "./addgeonotificationonwidgetmodal.vue?vue&type=script&lang=js"
export * from "./addgeonotificationonwidgetmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6a197",
  null
  
)

export default component.exports